import type { ReactNode } from "react";
import { Wordmark } from "@/components/ui";
import "./states.css";

type Tone = "neutral" | "success" | "danger" | "info";

/** Shared chrome for every terminal / not-found public screen. Content is
 *  passed in by each state so copy stays per-state and data-driven. */
export function StateScreen({
  tone = "neutral",
  eyebrow,
  title,
  children,
  quoteNumber,
  wide = false,
}: {
  tone?: Tone;
  eyebrow: string;
  title: string;
  children?: ReactNode;
  quoteNumber?: string;
  /** Roomier card — used when the body holds a breakdown table. */
  wide?: boolean;
}) {
  return (
    <div className="public-shell">
      <header className="public-shell__bar">
        <Wordmark subtitle="Quotes" />
        {quoteNumber ? <span className="public-shell__ref numeric">{quoteNumber}</span> : null}
      </header>
      <main className={`state-screen state-screen--${tone}`}>
        <div className={`state-screen__card${wide ? " state-screen__card--wide" : ""}`}>
          <p className="eyebrow">{eyebrow}</p>
          <h1>{title}</h1>
          <div className="state-screen__body">{children}</div>
        </div>
      </main>
      <footer className="public-shell__foot">
        <span>Arkitectly — residential architecture</span>
      </footer>
    </div>
  );
}

export function ContactLine() {
  return (
    <p className="state-screen__contact">
      Questions? Email{" "}
      <a href="mailto:hello@arkitectly.co.uk">hello@arkitectly.co.uk</a> and we’ll help.
    </p>
  );
}
